#import "./AccessGroupsFields.graphql"
query AccessGroups($first: Int!, $orderBy: [AccessGroupsOrderBy!]) {
  accessGroups(first: $first, orderBy: $orderBy) {
    nodes {
      ...AccessGroupsFields
    }
  }
}
